import React, { Component } from "react";

import withMobileDialog from "@material-ui/core/withMobileDialog";
import { withStyles } from "@material-ui/core/styles";

import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Slide
} from "@material-ui/core";

import { toast } from "react-toastify";

import { store } from "../firebase";

import { parseServiceFields } from "../utils";

import ServiceFields from "../components/ServiceFields";

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const styles = (theme) => ({
  title: {
    fontFamily: "Lumberjack Inline Rough",
    fontSize: 20
  }
});

class AddService extends Component {
  constructor(props) {
    super(props);

    this.state = { name: "", duration: 30, price: 0, color: "#f44336" };
  }

  componentDidMount() {}

  handleUpdate = (service) => {
    this.setState({ ...service });
  };

  handleAdd = () => {
    const { shop } = this.props;

    try {
      const toAdd = parseServiceFields(this.state);

      const toastId = toast("Wijzigingen bewaren...", {
        autoClose: false
      });

      const { name, color, duration, price } = toAdd;

      store
        .addService(shop.id, name, color, duration, price)
        .then(() => {
          toast.update(toastId, {
            render: "Wijzigingen bewaard",
            type: toast.TYPE.INFO,
            autoClose: 3000
          });

          this.handleClose();
        })
        .catch((error) => {
          toast.update(toastId, {
            render: `Er ging iets fout (${error.toString()})`,
            type: toast.TYPE.ERROR,
            autoClose: 5000
          });
        });
    } catch (error) {
      console.warn(error);
      if (error) {
        toast.error(error.toString());
      }
    }
  };

  handleClose = () => {
    this.props.onClose(this.props.selectedValue);
  };

  render() {
    const { classes, open, onClose, service, ...other } = this.props;

    return (
      <div>
        <Dialog
          TransitionComponent={Transition}
          open={open}
          onClose={this.handleClose}
        >
          <DialogTitle>
            <Typography className={classes.title}>
              Behandeling toevoegen
            </Typography>
          </DialogTitle>
          <DialogContent className={classes.content}>
            <ServiceFields service={this.state} onUpdate={this.handleUpdate} />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="secondary">
              Annuleren
            </Button>
            <Button onClick={this.handleAdd} color="primary">
              Toevoegen
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withMobileDialog()(withStyles(styles)(AddService));
